import AxiosFactory from "api/Axios/axiosFactory";

const baseURL = process.env.REACT_APP_API_BASE_URL;
const Axios = new AxiosFactory(baseURL).createInstance();

export default Axios;